import { ref } from 'vue';
import { useFloating, offset, flip, shift, autoPlacement, size, autoUpdate } from '@floating-ui/vue';

export function useDropdownFloating(placement: 'top' | 'bottom-start' = 'bottom-start') {
  const reference = ref(null)
  const floating = ref(null)

  const { floatingStyles } = useFloating(reference, floating, {
    placement,
    strategy: 'fixed',
    middleware: [
      offset(4),
      flip(),
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            width: `${rects.reference.width}px`,
          })
        },
      }),
    ],
  })

  return { reference, floating, floatingStyles }
}